
import { useForm } from 'react-hook-form';
import { useDispatch } from "react-redux";
import BihamtaTable from '../BihamtaTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import ModalEnlargeImage from "../../Components/Modals/ModalEnlargeImage";
import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { Alert, Button, Col, FormGroup, Modal, OverlayTrigger, Popover } from 'react-bootstrap';
import { getImageServerPath, invoiceTypes, isWebApp } from "../../store/api/CommonFunctions";
import { CardImage, CheckSquare, DashCircle, ExclamationCircle, InfoSquareFill, PlusCircle, Search } from "react-bootstrap-icons";
import { searchBorrowPorductsForUsedParts, searchProductForSelect, searchProducts4Invoice, searchProducts4StorageReports, searchUsedParts, searchUsedPartsBoM }
    from "../../store/api/GetAllProduct";
import ModalAddNewProductForSelect from './ModalAddNewProductForSelect';
const ModalProducts = (props) => {

    const resultTable = useRef();
    const dispatch = useDispatch();
    const currentRowIndex = useRef(0);
    const selectedPrice = useRef(null);
    const [error, setError] = useState(null);
    const { handleSubmit, register } = useForm();
    const [currentRow, setCurrentRow] = useState(null);
    const [searchByBoM, setBoMSearch] = useState(false);
    const [popImage, setPopImage] = useState({ show: false });
    const [modalNewProduct, setModalNewProduct] = useState({ show: false });
    const { productGrouppingType, setProductPopup, popData, defaultSalePrice, defaultSalePriceLabel, defaultStorages, hideNewProduct } = props;
    const { invoiceType, searchParts, setProductData, isGuarantee, show, value, customerCat, customerID, mainProductHardCode,
        isFormal, searchForBorrowUsedParts, staffID, staffName, forStorageReport } = popData;

    const showStorage = (invoiceType === invoiceTypes.Sale ||
        invoiceType === invoiceTypes.PreSale ||
        invoiceType === invoiceTypes.Havaleh ||
        invoiceType === invoiceTypes.ReturnFromPurchase ||
        invoiceType === invoiceTypes.ReturnFromSale ||
        invoiceType === invoiceTypes.Borrow ||
        invoiceType === invoiceTypes.ReturnFromBorrow ||
        invoiceType === invoiceTypes.OldParts ||
        invoiceType === invoiceTypes.Transfer || searchParts || searchForBorrowUsedParts);
    const showSalePrice =
        (invoiceType === invoiceTypes.Sale ||
            invoiceType === invoiceTypes.PreSale ||
            searchParts ||
            invoiceType === invoiceTypes.Transfer ||
            invoiceType === invoiceTypes.Borrow) && defaultSalePriceLabel?.length > 0;
    const pNameTitle = (Number(productGrouppingType) === 1 ? "نام " : "نوع ") + (searchParts ? "قطعه" : "کالا");
    const [resultList, onGetData] = useState([]);
    const hideAddNew = hideNewProduct || invoiceType === invoiceTypes.OldParts || invoiceType === invoiceTypes.ReturnFromBorrow || invoiceType === invoiceTypes.ReturnFromPurchase || invoiceType === invoiceTypes.ReturnFromSale || searchForBorrowUsedParts;
    const dontSetStg = invoiceType === invoiceTypes.Purchase || invoiceType === invoiceTypes.PrePurchase || invoiceType === invoiceTypes.Resid;
    let imageclicked = false;
    function closeModal() {
        currentRowIndex.current = 0;
        selectedPrice.current = null;
        setProductData(null);
        setCurrentRow(null);
        setProductPopup({ show: false });
    }
    const onInputKeyDown = useCallback((e) => {
        if (e.keyCode === 27) {
            closeModal();
        }
    });
    const popover = (
        <Popover id="popInfo" style={{ fontFamily: "Vazir", fontSize: "12px", zIndex: 10002 }}>
            <Popover.Content className='bodyStyle' style={{ color: "blue" }}>
                <label style={{ padding: 0, display: "block" }}>ENTER: جستجو</label>
                <label style={{ padding: 0, display: "block" }}>ESCAPE: انصراف</label>
                <label style={{ padding: 0, display: "block" }}>▲▼: حرکت در سطرها</label>
                <label style={{ padding: 0, display: "block" }}>SPACE: انتخاب سطر/کالا</label>
                <label style={{ padding: 0, display: "block" }}>+: جدا کردن بخش های مختلف نام کالا</label>
            </Popover.Content>
        </Popover>
    )
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
        { colTitle: "کد کالا", colName: "KalaCode", justInMobile: false },
        { colTitle: "مارک کالا", colName: "HolderName", justInMobile: true, showCondition: () => Number(productGrouppingType) !== 1 },
        { colTitle: pNameTitle, colName: "Name", justInMobile: true },
        { colTitle: "مدل کالا", colName: "Model", justInMobile: true },
        {
            colTitle: "نام انبار", colName: "StorageName", justInMobile: true, showCondition: () => showStorage,
        },
        {
            colTitle: "تعداد در فاکتور", colName: "SuggestedCount",
            showCondition: () => invoiceType === invoiceTypes.ReturnFromBorrow ||
                invoiceType === invoiceTypes.ReturnFromPurchase ||
                invoiceType === invoiceTypes.ReturnFromSale ||
                searchForBorrowUsedParts
        },
        {
            colTitle: "شماره فاکتور", colName: "InvoiceNumber",
            showCondition: () => invoiceType === invoiceTypes.ReturnFromBorrow ||
                invoiceType === invoiceTypes.ReturnFromPurchase ||
                invoiceType === invoiceTypes.ReturnFromSale ||
                searchForBorrowUsedParts
        },
        { colTitle: "تعداد در انبار", colName: "CountInStorage", justInMobile: false, showCondition: () => showStorage },
        {
            colTitle: defaultSalePriceLabel ?? "", colName: defaultSalePrice ?? "", colType: "currency", justInMobile: false,
            showCondition: () => showSalePrice
        },
        {
            colTitle: "آخرین خرید", colName: "LastPurchasePrice", colType: "currency",
            showCondition: () => invoiceType === invoiceTypes.Purchase || invoiceType === invoiceTypes.PrePurchase
        },
        { colTitle: "میانگین موزون", colName: "MeanAvgPrice", colType: "currency", showCondition: () => searchParts },
        { colTitle: "قیمت خرید", colName: "PurchasePrice", colType: "currency", showCondition: () => searchParts },
        { colTitle: <CardImage size={20} />, colName: "", justInMobile: false, showCondition: () => searchParts }
    ]    
    function search(data) {
        currentRowIndex.current = 0;
        let productCode = data.Code ?? "";
        let productName = data.Name ?? "";
        let productModel = data.Model ?? "";
        let holder = data.HolderName ?? "";
        let stgName = data.StorageName ?? "";
        if (productCode === '' && productName === '' && productModel === '' && holder === '' && stgName === '') {
            onGetData({ Error: "هیچکدام از کادرهای جستجو پر نشده است" });
            return;
        }
        data.Skip = 0;
        data.Take = data.Take ?? 5;
        onGetData("PENDING");
        if (invoiceType) {
            data.InvoiceType = invoiceType;
            data.CustomerID = customerID;
            data.CustomerCat = customerCat;
            data.IsFormal = isFormal;
            dispatch(searchProducts4Invoice(data, onGetData));
        }
        else if (forStorageReport) {
            searchProducts4StorageReports(data, onGetData);
        }
        else if (searchForBorrowUsedParts) {
            data.StaffID = staffID;
            searchBorrowPorductsForUsedParts(data, onGetData)
        }
        else if (searchParts) {

            searchUsedParts(data, onGetData);
        }
        else {
            data.InService = true;
            dispatch(searchProductForSelect(data, onGetData));
        }

    }
    function searchBoM(data) {
        currentRowIndex.current = 0;
        let productCode = data.Code ?? "";
        productCode = productCode.replace(/\s/g, '');
        let productName = data.Name ?? "";
        productName = productName.replace(/\s/g, '');
        let productModel = data.Model ?? "";
        productModel = productModel.replace(/\s/g, '');
        let holder = data.HolderName ?? "";
        holder = holder.replace(/\s/g, '');
        let stgName = (data.StorageName ?? "").replace(/\s/g, '');
        if (productCode === '' && productName === '' && productModel === '' && holder === '' && stgName === '') {
            onGetData({ Error: "هیچکدام از کادرهای جستجو پر نشده است" });
            return;
        }
        data.Skip = 0;
        data.Take = 5;
        searchUsedPartsBoM(data, mainProductHardCode, onGetData);
    }
    function select(index) {
        if (!show || !resultList || resultList.length === 0) {
            return;
        }
        if (index && !isNaN(index)) {
            if (currentRowIndex.current !== 0) {
                resultTable.current.rows[currentRowIndex.current].className = "resultTableRow";
            }
            currentRowIndex.current = index;
            resultTable.current.rows[index].className = "selectedResultTableRow";
        }
        let err = null;
        if (currentRowIndex.current < 1) {
            err = "ردیفی انتخاب نشده است";
        }
        setError(err);
        if (err) {
            return;
        }
        const item = resultList[currentRowIndex.current - 1];
        currentRowIndex.current = 0;
        if (imageclicked) {
            imageclicked = false;
            return;
        }
        const data = {
            ProductID: item.ID,
            ProductName:item.Name,
            ProductModel:item.Model,
            ProductHardCode: item.Hard_Code,
            PurchasePrice: item.MeanAvgPrice
        };

        if (searchParts || invoiceType) {
            if (!dontSetStg) {
                data.StorageID = item.StorageID;
                data.StorageName = item.StorageName;
            }
            data.IDForTaxOffice = item.IDForTaxOffice;
            if (!selectedPrice.current) {
                if (invoiceType === invoiceTypes.Purchase || invoiceType === invoiceTypes.PrePurchase) {
                    data.UnitPrice = item.LastPurchasePrice ?? 0;
                }
                else if (invoiceType === invoiceTypes.Transfer) {
                    data.UnitPrice = item.MeanAvgPrice;
                }
                else {
                    data.UnitPrice = isGuarantee === true ? item.GauranteeSalePrice : item[defaultSalePrice];
                }
            }
            else if (invoiceType === invoiceTypes.Sale || invoiceType === invoiceTypes.PreSale ||
                invoiceType === invoiceTypes.Purchase ||
                invoiceType === invoiceTypes.PrePurchase ||
                invoiceType === invoiceTypes.PrePurchase || searchParts || invoiceType === invoiceTypes.Transfer || invoiceType === invoiceTypes.Borrow) {
                data.UnitPrice = selectedPrice.current;
            }
            data.SuggestedCount = (item.SuggestedCount ?? 0) <= 0 ? 1 : item.SuggestedCount;
            if (invoiceType === invoiceTypes.ReturnFromBorrow ||
                invoiceType === invoiceTypes.ReturnFromPurchase ||
                invoiceType === invoiceTypes.ReturnFromSale) {
                data.ParentDetailID = item.ParentDetailID;
                data.UnitPrice = item.LastSalePrice;
                data.Tax = item.Tax;
                data.TaxPercent = item.TaxPercent;
                data.Discount = item.Discount;
                data.DiscountPercent = item.DiscountPercent;
            }
        }
        else if (searchForBorrowUsedParts) {
            data.UnitPrice = item.LastSalePrice;
            data.InvoiceDetailID = item.ParentDetailID;
            data.StorageID = item.StorageID;
            data.StorageName = item.StorageName;
            data.SuggestedCount = item.SuggestedCount;
        }
        data.HolderName = item.HolderName;
        if (setProductData) {
            setProductData(data);
        }
        setProductPopup({ show: false });
        selectedPrice.current = null;
        setCurrentRow(null);
        onGetData([]);
    }
    function magnify(imageName) {
        const onSuccess = (res) => {
            if (res.FilePath) {
                setPopImage({ show: true, imageUrl: res.FilePath });
            }
        }
        if (imageName && imageName !== "") {
            imageclicked = true;
            getImageServerPath(imageName, onSuccess);
        }
    }
    function tableKeyDown(e) {
        if (!show) {
            return;
        }
        if (e.key === ' ') {
            select();
        }
        else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            if (resultTable.current.rows.length > 0) {
                if (e.key === "ArrowDown" && currentRowIndex.current === resultTable.current.rows.length - 1) {
                    currentRowIndex.current = 0;
                }
                else if (e.key === "ArrowUp" && currentRowIndex.current <= 1) {
                    currentRowIndex.current = resultTable.current.rows.length;
                }
                if (e.key === "ArrowDown") {
                    currentRowIndex.current++;
                }
                else {
                    currentRowIndex.current--;
                }
                if (e.key === "ArrowDown" && currentRowIndex.current > 1) {
                    resultTable.current.rows[currentRowIndex.current - 1].className = "resultTableRow";
                }
                else if (e.key === "ArrowDown" && currentRowIndex.current === 1) {
                    resultTable.current.rows[resultTable.current.rows.length - 1].className = "resultTableRow";
                }
                if (e.key === "ArrowUp" && currentRowIndex.current < resultTable.current.rows.length - 1) {
                    resultTable.current.rows[currentRowIndex.current + 1].className = "resultTableRow";
                }
                else if (e.key === "ArrowUp" && currentRowIndex.current === resultTable.current.rows.length - 1) {
                    resultTable.current.rows[1].className = "resultTableRow";
                }
                resultTable.current.rows[currentRowIndex.current].className = "selectedResultTableRow";
                setCurrentRow({ ...resultList[currentRowIndex.current - 1] });
            }
        }
        else if (e.keyCode === 27) {
            closeModal();
        }
    }
    function rowClick(key) {
        if (currentRowIndex.current !== 0) {
            resultTable.current.rows[currentRowIndex.current].className = "resultTableRow";
        }
        currentRowIndex.current = key;
        resultTable.current.rows[key].className = "selectedResultTableRow";
        setCurrentRow(resultList[currentRowIndex.current - 1]);

    }
    function showModalNewProduct() {
        setModalNewProduct({
            productGroupingType: productGrouppingType,
            show: true,
            setProductData: setProductData,
            defaultStorages: defaultStorages,
            dontSetStg: dontSetStg
        });
        closeModal();
    }


    useEffect(() => {
        const inputPName = document.getElementById("modalProduct_Name");
        if (inputPName) {
            if (value && value !== ' ' && inputPName.value === "") {
                inputPName.value = value;
            }
            inputPName.focus();
        }

        document.addEventListener('keydown', tableKeyDown);

        return () => {
            document.removeEventListener('keydown', tableKeyDown);
        };
    }, [value, resultList, show])
    return (
        <Fragment>
            <ModalAddNewProductForSelect popData={modalNewProduct} setPopData={setModalNewProduct} />
            <Modal size='xl' show={show} style={{ direction: "rtl", zIndex: 1100 }} onHide={() => { }}>
                <Modal.Header className='headerStyle'>
                    <span>
                        <FontAwesomeIcon icon={faListAlt} size='lg' /> &nbsp;
                        انتخاب کالا از لیست
                    </span>
                    <span onClick={closeModal} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={faTimes} size='lg' /></span></Modal.Header>
                <Modal.Body className='bodyStyle'>
                    <ModalEnlargeImage popData={popImage} setPopData={setPopImage} />
                    <form onSubmit={handleSubmit(searchByBoM ? searchBoM : search)}>
                        <div className="row rowBorder">
                            {searchParts &&
                                <div className='rowTitle' style={{ direction: "" }}>
                                    <input type='checkbox' className='form-check-input' onChange={e => setBoMSearch(e.target.checked)} />
                                    &nbsp;
                                    <label>جستجو بر اساس فرمول ساخت</label>
                                </div>
                            }
                            {showStorage
                                &&
                                <Col md={2} className="form-group">
                                    <input type='text' placeholder='نام انبار' className="form-control" name="StorageName" ref={register({})}
                                        defaultValue={invoiceType === invoiceTypes.ReturnFromBorrow || invoiceType === invoiceTypes.OldParts ? "" : staffName ?? defaultStorages?.SrcStorageName ?? ""} />
                                </Col>
                            }
                            {(Number(productGrouppingType) === 1 /*|| searchParts*/) &&

                                <Col md={2} className="form-group">
                                    <input type="text" placeholder="کد کالا" className="form-control" name="Code" ref={register({})} onKeyDown={onInputKeyDown} />
                                </Col>
                            }
                            <Col md={2} className="form-group">
                                <input id="modalProduct_Name" type="text" placeholder={(Number(productGrouppingType) === 1) ? ('نام کالا') : ('نوع کالا')}
                                    className="form-control" ref={register({})} name="Name" onKeyDown={onInputKeyDown} />
                            </Col>
                            {Number(productGrouppingType) !== 1 && /*!searchParts &&*/
                                <Col md={2} className="form-group">
                                    <input type="text" placeholder="مارک کالا" className="form-control" ref={register({})} name="HolderName" onKeyDown={onInputKeyDown} />
                                </Col>
                            }
                            <Col md={2} className="form-group">
                                <input type="text" placeholder="مدل کالا" className="form-control" ref={register({})} name="Model" />
                            </Col>
                            <Col md={2} className="form-group">
                                <select className="form-control" ref={register({})} name="ProductOrPart" defaultValue={searchParts ? true : false}>
                                    <option value={false}>محصول</option>
                                    <option value={true}>قطعه</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group" >
                                <select className='form-control' defaultValue={10} ref={register({})} name="Take">
                                    <option value={5}>نمایش 5 ردیف در صفحه</option>
                                    <option value={10}>نمایش 10 ردیف در صفحه</option>
                                    <option value={20}>نمایش 20 ردیف در صفحه</option>
                                    <option value={50}>نمایش 50 ردیف در صفحه</option>
                                    <option value={100}>نمایش 100 ردیف در صفحه</option>
                                </select>
                            </Col>
                        </div>
                        <Button variant='secondary' className='mt-2 group-Btn' type='submit'><Search />&nbsp;جستجوی کالا</Button>
                        {!hideAddNew && <Button className='mt-2 group-Btn' onClick={showModalNewProduct}><PlusCircle size={17} />&nbsp; کالای جدید</Button>}
                    </form>
                    <BihamtaTable forceRowClickInMobile={true} columns={tableColes} tableRef={resultTable} style={{ whiteSpace: "noWrap" }} rowClick={(row) => rowClick(row.RowIndex + 1)} dataList={(resultList === "PENDING" || resultList.Error) ? resultList : { Data: resultList }} rowDoubleClick={(row) => select(row.RowIndex + 1)} />
                    {currentRow && (invoiceType === invoiceTypes.Sale || invoiceType === invoiceTypes.PreSale || invoiceType === invoiceTypes.Purchase || invoiceType === invoiceTypes.PrePurchase || searchParts || invoiceType === invoiceTypes.Transfer || invoiceType === invoiceTypes.Borrow) &&
                        <div style={{ padding: "10px", color: "blue", borderRadius: "3px", background: "linear-gradient(-45deg, #f3e4e4, transparent)" }}>
                            {(invoiceType === invoiceTypes.Sale || invoiceType === invoiceTypes.PreSale || searchParts || invoiceType === invoiceTypes.Transfer || invoiceType === invoiceTypes.Borrow) &&
                                <Fragment>
                                    <div className='form-check form-check-inline'>
                                        <label>قیمت فروش:&nbsp;</label>
                                        <label style={{ color: "#bb0e5f" }}>{currentRow.SalePrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</label>
                                        <input className='form-check-input' type='radio' name="SelectedSalePrice" style={{ marginRight: "2px", marginTop: "1px" }} onChange={() => selectedPrice.current = currentRow.SalePrice ?? 0} />
                                    </div>
                                    <div className='form-check form-check-inline'>
                                        <label>قیمت فروش سوم:&nbsp;</label>
                                        <label style={{ color: "#bb0e5f" }}>{currentRow.SalePrice3?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</label>
                                        <input className='form-check-input' type='radio' name="SelectedSalePrice" style={{ marginRight: "3px", marginTop: "1px" }} onChange={() => selectedPrice.current = currentRow.SalePrice3 ?? 0} />
                                    </div>
                                    <div className='form-check form-check-inline'>
                                        <label>قیمت فروش گارانتی:&nbsp;</label>
                                        <label style={{ color: "#bb0e5f" }}>{currentRow.GauranteeSalePrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</label>
                                        <input className='form-check-input' type='radio' name="SelectedSalePrice" style={{ marginRight: "3px", marginTop: "1px" }} onChange={() => selectedPrice.current = currentRow.GauranteeSalePrice ?? 0} />
                                    </div>
                                    <div className='form-check form-check-inline'>
                                        <label>قیمت آخرین فروش:&nbsp;</label>
                                        <label style={{ color: "#bb0e5f" }}>{currentRow.LastSalePrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</label>
                                        <input className='form-check-input' type='radio' name="SelectedSalePrice" style={{ margin: "3px", marginTop: "1px" }} onChange={() => selectedPrice.current = currentRow.LastSalePrice ?? 0} />
                                    </div>
                                </Fragment>
                            }
                            {(invoiceType === invoiceTypes.Purchase || invoiceType === invoiceTypes.PrePurchase) &&
                                <Fragment>
                                    <div className='form-check form-check-inline'>
                                        <label>میانگین موزون: &nbsp;</label>
                                        <label style={{ color: "#bb0e5f" }}>{currentRow.MeanAvgPrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</label>
                                        <input className='form-check-input' type='radio' name="SelectedPurchasePrice" style={{ margin: "3px" }} onChange={() => selectedPrice.current = currentRow.MeanAvgPrice ?? 0} />
                                    </div>
                                    <div className='form-check form-check-inline'>
                                        <label>قیمت خرید: &nbsp;</label>
                                        <label style={{ color: "#bb0e5f" }}>{currentRow.PurchasePrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</label>
                                        <input className='form-check-input' type='radio' name="SelectedPurchasePrice" style={{ margin: "3px" }} onChange={() => selectedPrice.current = currentRow.PurchasePrice ?? 0} />
                                    </div>
                                </Fragment>
                            }
                        </div>
                    }

                    <div>
                        <div style={{ direction: "rtl" }}>
                            <Button className='group-Btn' onClick={select}><CheckSquare size={16} />&nbsp;انتخاب کالا&nbsp;</Button>
                            <Button variant='danger' className='group-Btn' onClick={closeModal}><DashCircle size={16} />&nbsp;انصراف&nbsp;</Button>
                        </div>
                        {isWebApp() &&
                            <OverlayTrigger overlay={popover} trigger={["hover", "focus"]}>
                                <InfoSquareFill size={25} color='#ff5500' style={{ position: "absolute", left: "10px", bottom: "10px" }} />
                            </OverlayTrigger>
                        }
                    </div>
                    {invoiceType === invoiceTypes.ReturnFromSale &&
                        <Alert variant='warning' style={{ maxWidth: "50%" }} className='mt-2'><ExclamationCircle size={18} /> &nbsp; اگر قصد ارسال فاکتور به سازمان مالیات را دارید، کالاها را از یک فاکتور انتخاب کنید</Alert>
                    }
                </Modal.Body>
            </Modal >
        </Fragment>
    )
}
export default ModalProducts;